export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          APP下载
        </h2>

        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-lg p-6 md:p-10 text-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-background-50/20 -translate-y-1/2 translate-x-1/4"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-background-50/20 translate-y-1/3 -translate-x-1/4"></div>
          </div>

          <div className="relative z-10">
            <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-background-50/20 flex items-center justify-center">
              <i className="ri-smartphone-line text-3xl text-background-50"></i>
            </div>
            <h3 className="text-lg md:text-xl font-heading font-bold text-background-50 mb-2">
              51爆料网 APP — 随时随地吃瓜
            </h3>
            <p className="text-sm text-background-50/80 max-w-md mx-auto mb-6">
              下载51爆料网手机客户端，第一时间接收51爆料黑料推送通知。支持iOS和Android双平台，黑料不打烊，大瓜不错过。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 font-medium text-sm rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill text-lg"></i>
                iOS 版下载
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 text-background-50 border border-background-50/40 font-medium text-sm rounded-md hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 版下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}